import { useTranslation } from 'react-i18next';
import { CardActionDownload } from '@/common/components/CardActionDownload/CardActionDownload';
import { CardActionGroup } from '@/common/components/CardActionGroup/CardActionGroup';
import { TextField } from '@/common/components/Fields/TextField/TextField';
import { Icon } from '@/common/components/Icons/Icon';
import { Stack } from '@/common/components/Stack/Stack';
import { ICitizenCard } from '@/common/integrations/menhir/employee/employee/employee.types';

export type TCitizenCardDetailProps = {
  identification: ICitizenCard;
};

export function CitizenCardDetail({ identification }: TCitizenCardDetailProps) {
  const { t } = useTranslation();
  return (
    <Stack gap="md">
      <TextField
        id="number"
        label={t('identification_card_form.fields.number.label')}
        value={identification.details?.number ?? ''}
        disabled
        onChange={() => {}}
      />
      <CardActionGroup
        title={t('identification_card_form.fields.files.label')}
        description={t('identification_card_form.fields.files.description')}
      >
        <CardActionDownload
          title={t('dashboard.document_details.card_proof')}
          icon={<Icon icon="id-card" />}
          fileUrl={identification.files?.[0]?.url ?? ''}
        />
        {identification.files?.[1] && (
          <CardActionDownload
            title={t('dashboard.document_details.card_proof')}
            icon={<Icon icon="id-card" />}
            fileUrl={identification.files?.[1]?.url ?? ''}
          />
        )}
      </CardActionGroup>
    </Stack>
  );
}
